import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ToggleButtonGroup from '~/components/core/Molecules/Fields/ToggleButtonGroup';
import NotificationNavigationLink from '~/components/Notifications/NotificationNavigationLink';

import ClaimNotificationsCard from './ClaimNotificationsCard/ClaimNotificationsCard';

const SEEN_NOTIFICATIONS_OPTIONS = [
  {
    key: 'all',
    value: false,
    label: 'Show All',
  },
  {
    key: 'mine',
    value: true,
    label: 'Show Mine',
  },
];
export function ToggleSeenNotifications(props) {
  const { showOnlyCurrentUserNotifications, setShowOnlyCurrentUserNotifications } = props;

  return (
    <ToggleButtonGroup
      id="ToggleSeenNotifications"
      value={showOnlyCurrentUserNotifications}
      exclusive
      onChange={(event, newValue) => newValue !== null && setShowOnlyCurrentUserNotifications(newValue)}
      options={SEEN_NOTIFICATIONS_OPTIONS}
    />
  );
}

ToggleSeenNotifications.propTypes = {
  showOnlyCurrentUserNotifications: PropTypes.bool.isRequired,
  setShowOnlyCurrentUserNotifications: PropTypes.func.isRequired,
};

function ClaimNotificationsContainer() {
  const [isDismissedNotificationsShown, setIsDismissedNotificationsShown] = useState(false);

  return (
    <ClaimNotificationsCard
      useDefaultAssigneeFromPreferences
      onlyDismissed={isDismissedNotificationsShown}
      dismissedNavigationComponent={
        isDismissedNotificationsShown ? (
          <NotificationNavigationLink
            text="Back to active notifications"
            onClick={() => {
              setIsDismissedNotificationsShown(false);
            }}
          />
        ) : (
          <NotificationNavigationLink
            onClick={(e) => {
              e.preventDefault();
              setIsDismissedNotificationsShown(true);
            }}
            text="See dismissed notifications"
          />
        )
      }
    />
  );
}

ClaimNotificationsContainer.propTypes = {
  shouldDisplayNotifications: PropTypes.bool,
};

export default ClaimNotificationsContainer;
